import MosqueLogo from "@assets/prayer-time/Mosque-new.svg";
import prayerDetails from "@assets/prayer-time/PrayerTimetable.json";
import cx from "classnames";

import { CSVRow } from "./PrayerTime";

type PrayerTimeNewProps = {
  currentDate: string;
};

export default function PrayerTimeNew({ currentDate }: PrayerTimeNewProps) {
  const prayerData =
    prayerDetails.find((prayer) => {
      return prayer.Date === currentDate;
    }) ?? null;
  return (
    <div
      data-testid="prayer-time"
      className={cx("flex items-center justify-center h-full")}
    >
      <>
        {prayerData ? (
          <div className={cx("flex items-center gap-6 lg:gap-4 py-1")}>
            <div className={cx("")}>
              <img src={MosqueLogo} alt="Mosque Logo" height={17} width={20} />
            </div>
            {Object.keys(prayerData).map((key) => {
              if (key !== "Date" && key !== "Day") {
                return (
                  <div
                    key={key}
                    className={cx(
                      "font-primary text-center text-[11px] font-semibold leading-[120%]",
                    )}
                  >
                    <div className={cx("text-text-muted")}>{key}</div>
                    <div className={cx("text-grey-350")}>
                      {prayerData[key as keyof CSVRow].replace(" ", ":")}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        ) : (
          <p
            data-testid="prayer-times-not-available"
            className="prayer-times-not-available"
          >
            Prayer times for the current date are not available.
          </p>
        )}
      </>
    </div>
  );
}
